document.addEventListener('DOMContentLoaded', function() {
    // Pobieranie wszystkich elementów z klasą .menu-super__abox lub .menu-footer__abox
    const menuItems = document.querySelectorAll('.menu-super__abox, .menu-footer__abox');

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
            // Wyszukiwanie elementu svg-arrow w obrębie danego menu item
            const svgArrow = item.querySelector('.menu-super__desktop-svg-arrow, .menu-footer__desktop-svg-arrow');

            if (svgArrow) {
                const line = svgArrow.querySelector('line.line-inside-arrow');

                if (line) {
                    // Pobieranie bieżącej i docelowej wartości x2
                    let currentX2 = parseFloat(line.getAttribute('x2'));
                    const targetX2 = 40;
                    const step = 2;
                    const duration = 300; // czas trwania w milisekundach
                    const steps = Math.ceil((targetX2 - currentX2) / step); // liczba kroków
                    const intervalDuration = duration / steps; // czas trwania interwału

                    // Zatrzymywanie poprzedniego interwału
                    if (line.animationInterval) {
                        clearInterval(line.animationInterval);
                    }

                    // Zwiększanie wartości x2
                    line.animationInterval = setInterval(() => {
                        if (currentX2 < targetX2) {
                            currentX2 += step;
                            if (currentX2 > targetX2) currentX2 = targetX2;
                            line.setAttribute('x2', currentX2);
                        } else {
                            clearInterval(line.animationInterval);
                        }
                    }, intervalDuration);
                }
            }
        });

        item.addEventListener('mouseleave', function() {
            // Wyszukiwanie elementu svg-arrow w obrębie danego menu item
            const svgArrow = item.querySelector('.menu-super__desktop-svg-arrow, .menu-footer__desktop-svg-arrow');

            if (svgArrow) {
                const line = svgArrow.querySelector('line.line-inside-arrow');

                if (line) {
                    // Pobieranie bieżącej i oryginalnej wartości x2
                    let currentX2 = parseFloat(line.getAttribute('x2'));
                    const originalX2 = parseFloat(line.getAttribute('data-original-x2')) || 0;
                    const step = 2;
                    const duration = 300; // czas trwania w milisekundach
                    const steps = Math.ceil((currentX2 - originalX2) / step); // liczba kroków
                    const intervalDuration = duration / steps; // czas trwania interwału

                    // Zatrzymywanie poprzedniego interwału
                    if (line.animationInterval) {
                        clearInterval(line.animationInterval);
                    }

                    // Zmniejszanie wartości x2
                    line.animationInterval = setInterval(() => {
                        if (currentX2 > originalX2) {
                            currentX2 -= step;
                            if (currentX2 < originalX2) currentX2 = originalX2;
                            line.setAttribute('x2', currentX2);
                        } else {
                            clearInterval(line.animationInterval);
                        }
                    }, intervalDuration);
                }
            }
        });
    });
});
